import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "BEST DONUTS IN THE 956",
  "PINK GLAZE FOREVER",
  "FRESH · DAILY · 7 AM",
  "MADE WITH LOVE IN MCALLEN",
  "NUTELLA · STRAWBERRY · MAZAPAN",
  "ORDER ONLINE",
];

export const Ribbon = ({ bg = "#FF6392", color = "#FFF1F5" }) => {
  return (
    <div data-testid="ribbon-marquee" className="py-4 sm:py-6 border-y border-[#2D2327]/10" style={{ backgroundColor: bg }}>
      <Marquee gradient={false} speed={48} pauseOnHover>
        {Array.from({ length: 3 }).map((_, n) => (
          <React.Fragment key={n}>
            {ITEMS.map((t, i) => (
              <span
                key={`${n}-${i}`}
                className="ribbon-text mx-5 sm:mx-8 text-2xl sm:text-4xl lg:text-5xl font-serif-display"
                style={{ color }}
              >
                {t}
                <span className="mx-4 sm:mx-6 align-middle text-xl sm:text-2xl opacity-70">✺</span>
              </span>
            ))}
          </React.Fragment>
        ))}
      </Marquee>
    </div>
  );
};

export default Ribbon;
